var _a, _b, _c;
/**
 * 各端 WebView汇总：https://alidocs.dingtalk.com/i/nodes/2X3LRMZdxkAJpxQdD6byJGgrBYeOq5Ew
 */
export const ua = navigator.userAgent;
/**
 * [2022-05-27]
 *【已废弃】【已废弃】已废弃，不推荐使用！！（但不能移除，担心影响旧版本）
 * ==> 因为 isIOS 这个名称有很大的歧义，是判断苹果手机浏览器，还是苹果手机迅雷。(通常是判断苹果手机浏览器环境，但这里居然是判断苹果手机迅雷)
 * 所以如果要判断苹果手机浏览器环境，请使用：isIOSDevice；如果是判断苹果手机迅雷浏览器环境，请使用：isIOSNative
 */
export const isIOS = /(iPhone|iPad).* iThunder/i.test(ua);
/**
 * 判断是不是 iOS 系统浏览器环境
 */
export const isIOSDevice = /iPad|iPhone|iPod/i.test(ua) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
/**
 * 判断 iOS 手机迅雷 webview 环境
 */
export const isIOSNative = isIOS &&
    !!window.WebViewJavascriptBridge &&
    !!window.WebViewJavascriptBridge.callHandler;
/**
 * iOS 手机迅雷内，区分页面运行浏览器环境，App WebView，还是 Browser WebView
 */
export const isIOSAppWebView = isIOSNative && !/Browser/i.test(ua);
export const isIOSAppBrowserWebView = isIOSNative && /Browser/i.test(ua);
// ===================================================================================================================
/**
 * [2022-05-27]
 *【已废弃】【已废弃】已废弃，不推荐使用！！（但不能移除，担心影响旧版本）
 * ==> 因为 isAndroid 这个名称有很大的歧义，是判断Android手机浏览器，还是Android手机迅雷。(通常是判断Android手机浏览器环境，但这里居然是判断Android手机迅雷)
 * 而且兴广也进行了备注：内置新版浏览器没有这个标识，但有XLJSWebViewBridge 和 XLAccountJsBridge,所以需要从native api来判断最准确
 * 所以如果要判断Android手机浏览器环境，请使用：isAndroidDevice；如果是判断Android手机迅雷浏览器环境，请使用：isAndroidNative
 */
export const isAndroid = / Android .* iThunder/i.test(ua);
/**
 * 判断是不是 Android 系统浏览器环境
 */
export const isAndroidDevice = /Android/i.test(ua);
/**
 * 判断 Android 手机迅雷浏览器环境
 */
export const isAndroidNative = isAndroidDevice && !!window.XLJSWebViewBridge;
/**
 * Android 手机迅雷内，区分页面运行浏览器环境，App WebView，还是 Browser WebView
 */
export const isAndroidAppWebView = isAndroidNative && /iThunder/i.test(ua);
export const isAndroidAppBrowserWebView = isAndroidNative && !/iThunder/i.test(ua);
// ====================================================================================================================
/**
 * 【已废弃】【已废弃】已废弃，不推荐使用！！已废弃，不推荐使用！！但不能移除，担心影响旧版本。
 * ==> 同样因为 isMac 这个名称有很大的歧义，是判断 mac 系统浏览器，还是 mac 迅雷。(通常是判断 mac 浏览器环境，但这里居然是判断 mac 迅雷)
 * navigator.maxTouchPoints 不准确（之前兴广的注释）
 * 注：navigator.platform 会被废弃，尽早不再使用
 */
export const isMac = navigator.platform === 'MacIntel' && / Mac .* MacThunder/.test(ua);
/**
 * 判断是不是 mac 电脑设备
 * https://stackoverflow.com/questions/10527983/best-way-to-detect-mac-os-x-or-windows-computers-with-javascript-or-jquery
 * macppc|mac68k 的设备太老了，故移除
 */
export const isMacDevice = /(macintosh|macintel)/i.test(ua);
const isMacApp = isMacDevice &&
    !!window.WebViewJavascriptBridge &&
    !!window.WebViewJavascriptBridge.callHandler;
/**
 * Mac迅雷内，区分页面运行浏览器环境，App WebView，还是 Browser WebView
 */
export const isMacAppWebView = isMacApp && /MacThunder/i.test(ua);
export const isMacAppBrowserWebView = isMacApp && /ThunderBrowser/i.test(ua);
/**
 * [2022-12-19]
 * Mac迅雷内，运行在App WebView 或 Browser WebView中 即为MacNative。
 */
export const isMacNative = isMacAppWebView || isMacAppBrowserWebView;
/**
 * 判断为Mac迅雷的内置搜索浏览器
 */
export const isMacThunderBrowser = /thunderbrowser/i.test(ua);
/**
 * 判断为Mac迅雷是否为Mac App Store 版本
 * 版本号说明：中位版本号第二位区分渠道（0：官网版，1：MAS版）, 如5.20.x 为官网版本，5.21.x 为Mas版本
 */
export const isMasMacApp = Number((((_c = (_b = (_a = ua.match(/MacThunder\/([\d\.]+)/)) === null || _a === void 0 ? void 0 : _a[1]) === null || _b === void 0 ? void 0 : _b.split('.')) === null || _c === void 0 ? void 0 : _c[1]) || '').padEnd(2, '0')) %
    2 !==
    0 || false;
// ======================================================================================================================
/**
 * Windows PC 迅雷客户端 webview的判断。
 * （注意：如果是web开发的客户端插件，比如群组聊天，是集成到客户端里面，那这个判断会是 false）
 */
const isWindowsXunleiPcWebview = /Thunder/i.test(ua) && !!window.native && !!window.native.DetachNativeEvent;
/**
 * 【已废弃】【已废弃】已废弃，不推荐使用！！已废弃，不推荐使用！！但不能移除，担心影响旧版本。
 */
export const isPC = isWindowsXunleiPcWebview;
/**
 * 是否在迅雷11内。
 * 请使用这个，语义更明确！！
 */
export const isPCNative = isWindowsXunleiPcWebview;
/**
 * 迅雷11内，区分页面运行浏览器环境，App WebView，还是 Browser WebView
 */
export const isPCAppWebView = isWindowsXunleiPcWebview && !/TBC/i.test(ua);
export const isPCAppBrowserWebView = isWindowsXunleiPcWebview && /TBC/i.test(ua);
/**
 * 是否支持xbase 的XBase Jsbridge
 */
export const isXbaseNative = !!window.XBaseObject;
/**
 * 是否为微信内置浏览器
 */
export const isWX = /micromessenger/gi.test(ua);
/**
 * 是否为QQ内置浏览器
 */
export const isQQ = /qq\/([\d.]+)/gi.test(ua);
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicGxhdGZvcm0uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvbGliL3BsYXRmb3JtLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQTs7R0FFRztBQUNILE1BQU0sQ0FBQyxNQUFNLEVBQUUsR0FBRyxTQUFTLENBQUMsU0FBUyxDQUFDO0FBRXRDOzs7OztHQUtHO0FBQ0gsTUFBTSxDQUFDLE1BQU0sS0FBSyxHQUFHLDJCQUEyQixDQUFDLElBQUksQ0FBQyxFQUFFLENBQUMsQ0FBQztBQUUxRDs7R0FFRztBQUNILE1BQU0sQ0FBQyxNQUFNLFdBQVcsR0FDdEIsbUJBQW1CLENBQUMsSUFBSSxDQUFDLEVBQUUsQ0FBQztJQUM1QixDQUFDLFNBQVMsQ0FBQyxRQUFRLEtBQUssVUFBVSxJQUFJLFNBQVMsQ0FBQyxjQUFjLEdBQUcsQ0FBQyxDQUFDLENBQUM7QUFFdEU7O0dBRUc7QUFDSCxNQUFNLENBQUMsTUFBTSxXQUFXLEdBQ3RCLEtBQUs7SUFDTCxDQUFDLENBQUMsTUFBTSxDQUFDLHVCQUF1QjtJQUNoQyxDQUFDLENBQUMsTUFBTSxDQUFDLHVCQUF1QixDQUFDLFdBQVcsQ0FBQztBQUUvQzs7R0FFRztBQUNILE1BQU0sQ0FBQyxNQUFNLGVBQWUsR0FBRyxXQUFXLElBQUksQ0FBQyxVQUFVLENBQUMsSUFBSSxDQUFDLEVBQUUsQ0FBQyxDQUFDO0FBQ25FLE1BQU0sQ0FBQyxNQUFNLHNCQUFzQixHQUFHLFdBQVcsSUFBSSxVQUFVLENBQUMsSUFBSSxDQUFDLEVBQUUsQ0FBQyxDQUFDO0FBRXpFLHNIQUFzSDtBQUV0SDs7Ozs7O0dBTUc7QUFDSCxNQUFNLENBQUMsTUFBTSxTQUFTLEdBQUcsdUJBQXVCLENBQUMsSUFBSSxDQUFDLEVBQUUsQ0FBQyxDQUFDO0FBRTFEOztHQUVHO0FBQ0gsTUFBTSxDQUFDLE1BQU0sZUFBZSxHQUFHLFVBQVUsQ0FBQyxJQUFJLENBQUMsRUFBRSxDQUFDLENBQUM7QUFFbkQ7O0dBRUc7QUFDSCxNQUFNLENBQUMsTUFBTSxlQUFlLEdBQUcsZUFBZSxJQUFJLENBQUMsQ0FBQyxNQUFNLENBQUMsaUJBQWlCLENBQUM7QUFFN0U7O0dBRUc7QUFDSCxNQUFNLENBQUMsTUFBTSxtQkFBbUIsR0FBRyxlQUFlLElBQUksV0FBVyxDQUFDLElBQUksQ0FBQyxFQUFFLENBQUMsQ0FBQztBQUMzRSxNQUFNLENBQUMsTUFBTSwwQkFBMEIsR0FDckMsZUFBZSxJQUFJLENBQUMsV0FBVyxDQUFDLElBQUksQ0FBQyxFQUFFLENBQUMsQ0FBQztBQUUzQyx1SEFBdUg7QUFFdkg7Ozs7O0dBS0c7QUFDSCxNQUFNLENBQUMsTUFBTSxLQUFLLEdBQ2hCLFNBQVMsQ0FBQyxRQUFRLEtBQUssVUFBVSxJQUFJLG9CQUFvQixDQUFDLElBQUksQ0FBQyxFQUFFLENBQUMsQ0FBQztBQUVyRTs7OztHQUlHO0FBQ0gsTUFBTSxDQUFDLE1BQU0sV0FBVyxHQUFHLHVCQUF1QixDQUFDLElBQUksQ0FBQyxFQUFFLENBQUMsQ0FBQztBQUU1RCxNQUFNLFFBQVEsR0FDWixXQUFXO0lBQ1gsQ0FBQyxDQUFDLE1BQU0sQ0FBQyx1QkFBdUI7SUFDaEMsQ0FBQyxDQUFDLE1BQU0sQ0FBQyx1QkFBdUIsQ0FBQyxXQUFXLENBQUM7QUFFL0M7O0dBRUc7QUFDSCxNQUFNLENBQUMsTUFBTSxlQUFlLEdBQUcsUUFBUSxJQUFJLGFBQWEsQ0FBQyxJQUFJLENBQUMsRUFBRSxDQUFDLENBQUM7QUFDbEUsTUFBTSxDQUFDLE1BQU0sc0JBQXNCLEdBQUcsUUFBUSxJQUFJLGlCQUFpQixDQUFDLElBQUksQ0FBQyxFQUFFLENBQUMsQ0FBQztBQUU3RTs7O0dBR0c7QUFDSCxNQUFNLENBQUMsTUFBTSxXQUFXLEdBQUcsZUFBZSxJQUFJLHNCQUFzQixDQUFDO0FBRXJFOztHQUVHO0FBQ0gsTUFBTSxDQUFDLE1BQU0sbUJBQW1CLEdBQUcsaUJBQWlCLENBQUMsSUFBSSxDQUFDLEVBQUUsQ0FBQyxDQUFDO0FBRTlEOzs7R0FHRztBQUNILE1BQU0sQ0FBQyxNQUFNLFdBQVcsR0FDdEIsTUFBTSxDQUNKLENBQUMsQ0FBQSxNQUFBLE1BQUEsTUFBQSxFQUFFLENBQUMsS0FBSyxDQUFDLHVCQUF1QixDQUFDLDBDQUFHLENBQUMsQ0FBQywwQ0FBRSxLQUFLLENBQUMsR0FBRyxDQUFDLDBDQUFHLENBQUMsQ0FBQyxLQUFJLEVBQUUsQ0FBQyxDQUFDLE1BQU0sQ0FDcEUsQ0FBQyxFQUNELEdBQUcsQ0FDSixDQUNGO0lBQ0MsQ0FBQztJQUNELENBQUMsSUFBSSxLQUFLLENBQUM7QUFFZix5SEFBeUg7QUFFekg7OztHQUdHO0FBQ0gsTUFBTSx3QkFBd0IsR0FDNUIsVUFBVSxDQUFDLElBQUksQ0FBQyxFQUFFLENBQUMsSUFBSSxDQUFDLENBQUMsTUFBTSxDQUFDLE1BQU0sSUFBSSxDQUFDLENBQUMsTUFBTSxDQUFDLE1BQU0sQ0FBQyxpQkFBaUIsQ0FBQztBQUU5RTs7R0FFRztBQUNILE1BQU0sQ0FBQyxNQUFNLElBQUksR0FBRyx3QkFBd0IsQ0FBQztBQUU3Qzs7O0dBR0c7QUFDSCxNQUFNLENBQUMsTUFBTSxVQUFVLEdBQUcsd0JBQXdCLENBQUM7QUFFbkQ7O0dBRUc7QUFDSCxNQUFNLENBQUMsTUFBTSxjQUFjLEdBQUcsd0JBQXdCLElBQUksQ0FBQyxNQUFNLENBQUMsSUFBSSxDQUFDLEVBQUUsQ0FBQyxDQUFDO0FBQzNFLE1BQU0sQ0FBQyxNQUFNLHFCQUFxQixHQUNoQyx3QkFBd0IsSUFBSSxNQUFNLENBQUMsSUFBSSxDQUFDLEVBQUUsQ0FBQyxDQUFDO0FBRTlDOztHQUVHO0FBQ0gsTUFBTSxDQUFDLE1BQU0sYUFBYSxHQUFHLENBQUMsQ0FBQyxNQUFNLENBQUMsV0FBVyxDQUFDO0FBRWxEOztHQUVHO0FBQ0gsTUFBTSxDQUFDLE1BQU0sSUFBSSxHQUFHLGtCQUFrQixDQUFDLElBQUksQ0FBQyxFQUFFLENBQUMsQ0FBQztBQUVoRDs7R0FFRztBQUNILE1BQU0sQ0FBQyxNQUFNLElBQUksR0FBRyxnQkFBZ0IsQ0FBQyxJQUFJLENBQUMsRUFBRSxDQUFDLENBQUMifQ==